export default function R_Syllabus() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Syllabus Component</h1>
      <p>This is the R_Syllabus tutorial section.</p>
    </div>
  );
}
